// log.service.ts
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {RewardService} from "./reward.service";

@Injectable({
    providedIn: 'root',
})
export class LogService {
    constructor(private http: HttpClient) {}

    log(loglevel: any, message: any, environment, banner) {
        const logData = {
            message: message,
            level: loglevel
        };
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        const nodeServerurl = this.getMobileApplicationDomainURL(environment, banner) + '/ocrp-rewards-ui/log';
        this.http.post(nodeServerurl, logData, httpOptions).subscribe(
            response => {
                console.log('Log sent successfully', response);
            },
            error => {
                console.error('Error sending log', error);
            }
        );
    }

    public getMobileApplicationDomainURL(currentEnvironment, banner) {
        let domain = '';
        if (currentEnvironment.indexOf('prod') >= 0) {
            domain = 'https://www.' + banner + '.com';
        } else {
            domain = 'https://www-' + currentEnvironment + '.' + banner + '.com';
        }
        return domain;
    }
}
